<template>
  <ContactsSelect
    v-model:selected-contacts="selected_users"
    :companies="[workspace.record]"
    :excluded-contacts="workspace.contacts"
    :multi-select="true"
    :label="$t('Select or Add Contact')" />

  <TextInput
    v-if="show_name_inputs"
    v-model="first_name"
    :validate-on-input="true"
    class="m-3"
    :show-label="true"
    :label="$t('First Name')"
    :classes="'w-full'"
    input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
    name="first_name"
    type="text"
    :placeholder="$t('First Name')" />

  <TextInput
    v-if="show_name_inputs"
    v-model="last_name"
    :validate-on-input="true"
    class="m-3"
    :show-label="true"
    :label="$t('Last Name')"
    :classes="'w-full'"
    input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
    name="last_name"
    type="text"
    :placeholder="$t('Last Name')" />

  <SelectDropDownMenu
    v-model:current-item="contact_permission"
    :is-box-background="true"
    :allow-null="false"
    name="tag"
    label-attr="label"
    value-attr="value"
    :items="permission_selections"
    :placeholder="$t('Permission')"
    :label="$t('Permission')"
    :show-label="true"
    class="w-full font-normal mt-6"
    :input-classes="`w-44 sm:text-sm appearance-none h-10 font-medium text-gray-700 text-left block px-1 py-2 rounded-lg shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light`" />

  <div class="flex gap-2 w-full flex-row justify-between mt-3">
    <button type="button" class="cancel-btn w-1/2 m-0 border-light-divider-border dark:border-dark-divider-border" @click="$emit('cancel')">
      {{ $t("Cancel") }}
    </button>
    <button :disabled="!required_filled" class="primary-btn w-1/2" @click="handleAddContact">
      <span class="mr-5 whitespace-nowrap"> {{ $t("Add Collaborator") }} </span>
    </button>
  </div>
</template>

<script>
import ContactsSelect from "@/components/shared/ContactsSelect.vue"

import TextInput from "@/components/shared/TextInput.vue"
import SelectDropDownMenu from "@/components/shared/SelectDropDownMenu.vue"

export default {
  components: { ContactsSelect, SelectDropDownMenu, TextInput },
  props: { workspace: null },
  emits: ["done", "cancel"],
  data() {
    return {
      selected_users: [],
      contact_permission: "read",
      permission_selections: [
        { label: this.$t("Viewer"), value: "read" },
        { label: this.$t("Editor"), value: "write" },
        { label: this.$t("Admin"), value: "admin" }
      ],
      first_name: "",
      last_name: ""
    }
  },
  computed: {
    required_filled() {
      if (this.show_name_inputs) {
        return this.selected_users.length && this.first_name && this.last_name
      }
      return this.selected_users.length
    },
    show_name_inputs() {
      if (!this.selected_users.length) {
        return false
      }
      if (!this.selected_users[0].id) {
        return true
      }
      return false
    }
  },
  watch: {},

  created() {},

  methods: {
    handleAddContact() {
      const data = {
        short_id: this.workspace.short_id,
        access_scope: this.contact_permission
      }
      if (this.selected_users[0]?.id) {
        data["contact_id"] = this.selected_users[0]?.id
      } else {
        data["contact"] = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.selected_users[0].email
        }
      }

      this.$store.dispatch("ui/showLoading")

      if (!this.workspace.contacts.map((t) => t.id).includes(this.selected_users[0]?.id)) {
        this.$store
          .dispatch("data/addWorkspaceCollaborator", data)
          .then(() => {
            this.$emit("done")
            this.$store.dispatch("ui/hideLoading")
          })
          .catch(() => {
            this.$store.dispatch("ui/hideLoading")
          })
      } else {
        this.$store.dispatch("ui/hideLoading")
        this.$emit("done")
      }
    }
  }
}
</script>
